module.exports = __webpack_public_path__ + "img/zhongxun-data-list-0.640b62e9.png";